import React from 'react';

const URLQRForm = ({ qrText, onTextChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="qrText">URL</label>
      <input
        id="qrText"
        type="url"
        value={qrText}
        onChange={(e) => onTextChange(e.target.value)}
        placeholder="https://seusite.com"
        className="text-input"
      />
      <small>Digite uma URL válida (http:// ou https://)</small>
    </div>
  );
};

export default URLQRForm;
